import { createReducer, on } from "@ngrx/store";
import { VoucherStateInterface } from "./voucherState.interface";
import {
  invokeVouchersForLocationPartner,
  resultVouchersForLocationPartner,
} from "./voucher.action";

export const initialState: Readonly<VoucherStateInterface> = {
  vouchers: null,
  loading: false,
  voucherFilter: {
    locationPartnerEmail : "",
    code: null,
    endDate: null,
    sortName: null,
    startDate: null,
    pager: {
      pageNumber: 1,
      pageSize: 10,
    },
    status : []
  },
};

export const VoucherReducer = createReducer(
  initialState,
  on(invokeVouchersForLocationPartner, (state) => ({
    ...state,
    loading: true,
  })),
  on(resultVouchersForLocationPartner, (state, { vouchers }) => ({
    ...state,
    vouchers: vouchers,
    loading: false,
  }))
);
